<template>
    <div>
        <div v-if="getSpecificMediaDiffs(diff.diffs, 'order').length > 0" class="my-3">
                       <span :style="'background-color:' + updateColors.light " class="p-2">
                            <v-icon>import_export</v-icon>
                            L'ordre des photos a été changé.
                        </span>
        </div>

        <div class="row m-0 medias-box"
             v-if="getSpecificMediaDiffs(diff.diffs, 'add&update').length > 0">
            <div class="col-6 col-lg-4 col-xl-3"
                 v-for="mediaDiff in getSpecificMediaDiffs(diff.diffs, 'add&update')"
                 v-if="(getDiffMediaData(mediaDiff).is_404 === undefined || !getDiffMediaData(mediaDiff).is_404)
                              && getDiffMediaData(mediaDiff).is_image">
                <v-card class="p-2" :style="'background-color:' + getBackgroundColor(mediaDiff)">
                    <a :href="getDiffMediaData(mediaDiff).url" target="_blank">
                        <v-img class="v-media"
                               :src="(getDiffMediaData(mediaDiff).thumbnail_url !== null) ?
                                            getDiffMediaData(mediaDiff).thumbnail_url : getDiffMediaData(mediaDiff).url">
                            <div class="media-logo"
                                 v-if="getDiffMediaData(mediaDiff).source !== undefined &&
                                             getDiffMediaData(mediaDiff).source !== null &&
                                              getDiffMediaData(mediaDiff).source.type !== 'APIDAE'">
                                <img
                                  :src="'/images/logo-' + getDiffMediaData(mediaDiff).source.type + '.jpg'">
                            </div>
                        </v-img>
                    </a>

                    <v-card-text :style="'background-color:' + getBackgroundColor(mediaDiff)">
                        <v-text-field label="Titre" v-model="getDiffMediaData(mediaDiff).name" outlined
                                      class="mb-3"
                                      :class="getInputClass(mediaDiff, 'name')" readonly>
                        </v-text-field>
                        <v-text-field
                          :class="getInputClass(mediaDiff, 'copyright')"
                          label="Copyright" v-model="getDiffMediaData(mediaDiff).copyright"
                          outlined readonly>
                        </v-text-field>
                    </v-card-text>
                </v-card>
            </div>
        </div>

        <div v-if="getSpecificMediaDiffs(diff.diffs, 'delete').length > 0" class="mt-4">
            <v-expansion-panels>
                <v-expansion-panel :style="'background-color:' + deleteColors.light">
                    <v-expansion-panel-header :style="'background-color:' + deleteColors.light">
                                <span class="text-danger">
                            <v-icon color="red">delete_outline</v-icon>
                            Les photos suivantes ont été supprimées :
                        </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="row m-0 medias-box">
                            <div class="col-6 col-lg-4 col-xl-3"
                                 v-for="mediaDiff in getSpecificMediaDiffs(diff.diffs, 'delete')"
                                 v-if="(mediaDiff.old.is_404 === undefined || !mediaDiff.old.is_404)
                              && mediaDiff.old.is_image">
                                <v-card class="p-2 border border-danger"
                                        :style="'background-color:' + deleteColors.light">
                                    <a :href="mediaDiff.old.url" target="_blank">
                                        <v-img class="v-media"
                                               :src="(mediaDiff.old.thumbnail_url !== null) ?
                                            mediaDiff.old.thumbnail_url : mediaDiff.old.url">
                                            <div class="media-logo"
                                                 v-if="mediaDiff.old.source !== undefined &&
                                             mediaDiff.old.source !== null &&
                                              mediaDiff.old.source.type !== 'APIDAE'">
                                                <img
                                                  :src="'/images/logo-' + mediaDiff.old.source.type + '.jpg'">
                                            </div>
                                        </v-img>
                                    </a>

                                    <v-card-text :style="'background-color:' + deleteColors.light">
                                        <v-text-field label="Titre" v-model="mediaDiff.old.name" outlined
                                                      class="mb-3"
                                                      readonly>
                                        </v-text-field>
                                        <v-text-field
                                          label="Copyright" v-model="mediaDiff.old.copyright"
                                          outlined readonly>
                                        </v-text-field>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "MediaFieldDiffs",
    props: ["diff"],
    methods: {
        getSpecificMediaDiffs(diffs, type) {
            if (type === "add&update") {
                return diffs.filter(diff => diff.type === "ADDED" ||
                  (diff.type === "UPDATED" && diff.metadata.attribute !== "order") ||
                  (diff.type === "DELETED" && Object.keys(diff.metadata).length > 0))
            } else if (type === "delete") {
                return diffs.filter(diff => diff.type === "DELETED" && Object.keys(diff.metadata).length === 0)
            } else if (type === "order") {
                return diffs.filter(diff => diff.type === "UPDATED" && diff.metadata.attribute === "order")
            }
        },
        getDiffMediaData(diff) {
            if (Object.keys(diff.metadata).length > 0) {
                return diff.metadata.media
            } else {
                return diff.new
            }
        },
        getInputClass(diff, attribute) {
            if (diff.type === "DELETED" &&
              diff.metadata.attribute === attribute) {
                return "input-error"
            } else if (diff.type === "ADDED" && diff.metadata.attribute && diff.metadata.attribute === attribute) {
                return "input-add"
            } else if (diff.type === "UPDATED" && diff.metadata.attribute && diff.metadata.attribute === attribute) {
                return "input-update"
            } else if(diff.type === "UPDATED" && diff.metadata.attribute &&
              diff.metadata.attribute === 'name&copyright') {
                if(attribute === "name") {
                    if(diff.new.name === null || diff.new.name === '') {
                        return "input-error"
                    } else if(diff.old.name === null || diff.old.name === '') {
                        return "input-add"
                    } else {
                        return "input-update"
                    }
                } else if(attribute === "copyright") {
                    if(diff.new.copyright === null || diff.new.copyright === '') {
                        return "input-error"
                    } else if(diff.old.copyright === null || diff.old.copyright === '') {
                        return "input-add"
                    } else {
                        return "input-update"
                    }
                }
            }
        },
        getBackgroundColor(diff) {
            if (diff.type === "ADDED" && !diff.metadata.attribute) {
                return this.addColors.light
            } else {
                return "#e3e1e1"
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>